/* @flow */

export function getAvatarImages(avatar) {
  // eslint-disable-line import/prefer-default-export
  return size => {
    switch (size) {
      case 'xsmall':
        return [avatar.small, avatar.small, avatar.medium];
      case 'small':
      case 'medium':
        return [avatar.small, avatar.medium];
      case 'large':
        return [avatar.medium, avatar.large];
      case 'xlarge':
        return [avatar.large];
      default:
    }
    return [avatar.small, avatar.medium, avatar.large];
  };
}
